import ProductTeaser from '~/themes/base/components/product/ProductTeaser'
import eventDefinitions from '~/events/eventDefinitions'

export default {
  extends: ProductTeaser,
  props: {
    searchQuery: {
      type: String,
    },
    mode: {
      type: String,
      default: 'teaser',
    },
  },
  methods: {
    trackSearchClick() {
      this.$eventBus.$emit(eventDefinitions.SEARCH.RESULTS, {
        query: this.searchQuery,
        location: 'searchresults',
        items: [this.product],
        productTeaser: true,
      })
    },
  },
}
